import React from "react";
import { Popover, Button, Typography } from "antd";
import { Info } from "lucide-react";
import { defaultColors } from '@/themes/antd-theme';

const { Paragraph } = Typography;

const InfoComment = ({ title, content }) => {
  return (
    <Popover
      placement="leftTop"
      title={title}
      overlayClassName="custom-popover-width"
      content={
        <div className="max-w-[800px] max-h-[200px] overflow-auto whitespace-normal text-sm">
          <Paragraph
            ellipsis={{
              rows: 5,
              expandable: true,
              symbol: "more",
            }}
            className="m-0 whitespace-pre-wrap"
          >
            <i>{content}</i>
          </Paragraph>
        </div>
      }
    >
      <Button
        type="text"
        icon={<Info size={20} style={{ color: defaultColors.primary }} />}
      />
    </Popover>
  );
};

export default InfoComment;
